module.exports = __webpack_public_path__ + "img/1.33036ab4.svg";